import cls from "classnames"

import ActivityLog from "./ActivityLog/ActivityLog"
import DisputeFields from "./DisputeFields/DisputeFields"
import EnrichmentBreakdown from "./EnrichmentBreakdown/EnrichmentBreakdown"
import HeroCard from "./HeroCard/HeroCard"
import RecommendationBlock from "./RecommendationBlock/RecommendationBlock"

import detailStyles from "../../detail.module.less"
import styles from "./detailsTab.module.less"

// Statuses whose outcome is settled: the enrichment score and the recommendation stop
// being actionable advice, so both blocks drop out.
const RESOLVED = ["won", "lost_defended", "lost_undefended", "skipped"]

// The default tab: the hero strip, then the grouped fields on the left with the
// always-visible activity panel on the right.
//
// `active` rather than the caller rendering us conditionally: the page tabs would
// otherwise unmount this on every switch away and re-fetch the team members each time
// the merchant comes back.
const DetailsTab = ({
  active,
  dispute,
  disputeId,
  status,
  statusInfo,
  enrichmentBreakdown,
  recommendation,
  activity,
  escalated,
  stageLabel,
  isActionable,
  autoSubmitAt,
  onAssigneeChange
}) => {
  if (!active) return null

  const showBreakdown = !!enrichmentBreakdown && !RESOLVED.includes(status)
  // Only meaningful while the dispute is still actionable: hide it once evidence is
  // submitted (pending_decision) or the outcome is final, and never show 'none'.
  const showRecommendation =
    !!recommendation?.action &&
    recommendation.action !== "none" &&
    ![...RESOLVED, "pending_decision"].includes(status)

  return (
    <aside className={cls(detailStyles.rail, detailStyles.railTab)}>
      <div className={detailStyles.railScroll}>
        <HeroCard
          dispute={dispute}
          disputeId={disputeId}
          statusInfo={statusInfo}
          onAssigneeChange={onAssigneeChange}
        />
        <div className={styles.detailtab}>
          <div className={styles.main}>
            {showBreakdown ? (
              <EnrichmentBreakdown breakdown={enrichmentBreakdown} isActionable={isActionable} />
            ) : null}
            {showRecommendation ? <RecommendationBlock recommendation={recommendation} /> : null}
            <DisputeFields
              dispute={dispute}
              status={status}
              escalated={escalated}
              stageLabel={stageLabel}
              isActionable={isActionable}
              autoSubmitAt={autoSubmitAt}
              showPlainEnrichment={!showBreakdown}
            />
          </div>
          <ActivityLog dispute={dispute} activity={activity} />
        </div>
      </div>
    </aside>
  )
}

export default DetailsTab
